import React from 'react'
import { Box, Link } from '@mui/material'
import { colors } from '../themes/colors'
import { toast } from 'react-toastify'
import MaterialSymbol from './MaterialSymbol'
import { TestIds } from '../testIds'

interface ShareButtonProps {
  label: string
  content: {
    title: string
    text: string
    url?: string
  }
}
export const ShareButton: React.FC<ShareButtonProps> = (props) => {
  const onClick = () => {
    if (navigator.share) {
      navigator
        .share(props.content)
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error))
    } else {
      navigator.clipboard
        .writeText(props.content.text)
        .then(() => {
          toast('Details copied to clipboard', {
            type: 'success',
            icon: <MaterialSymbol>inventory</MaterialSymbol>,
          })
        })
        .catch(() => {
          toast('Copy to clipboard unsuccesful', {
            type: 'error',
          })
        })
    }
  }
  return (
    <Box
      onClick={onClick}
      sx={{ display: 'flex', mt: 'auto', gap: '4px', color: colors.primary500, cursor: 'pointer' }}
    >
      <MaterialSymbol>ios_share</MaterialSymbol>
      <Link variant='body2' data-testid={TestIds.feat.orders.details.shareOrder}>
        {props.label}
      </Link>
    </Box>
  )
}

export default ShareButton
